module.exports = __webpack_public_path__ + "static/media/ic-enabled.368a496f.svg";